import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { authFetch } from "../../api/api";
import Card from "../../UI/Card";
import Button from "../../UI/Button";
import ConfirmModal from "../../UI/ConfirmModal";
import ExtraExpensesModal from "../modals/ExtraExpensesModal";
import { useTranslation } from "react-i18next";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

const API_URL = `${BASE_URL}/api/orders/`;

export default function ExpensesOrderPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [expenseToDelete, setExpenseToDelete] = useState(null);
  const [expenseModal, setExpenseModal] = useState(null);
  
  const { t } = useTranslation("OrdersPage");

  useEffect(() => {
    const load = async () => {
      try {
        const res = await authFetch(`${API_URL}${id}/`);
        if (!res.ok) throw new Error(t("loading_error"));

        const data = await res.json();
        setOrder(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id]);

  if (loading) return <div>{t("loading")}</div>;
  if (!order) return <div>{t("not_found")}</div>;
  

  const handleDelete = async () => {
    if (!expenseToDelete) return;

    try {
      const res = await authFetch(
        `${API_URL}${id}/expenses/${expenseToDelete.id}/`,
        {
          method: "DELETE",
        }
      );

      if (!res.ok) throw new Error(t("delete_error"));

      setOrder((prev) => ({
        ...prev,
        extra_expenses: prev.extra_expenses.filter(
          (e) => e.id !== expenseToDelete.id
        ),
      }));

      setShowDeleteConfirm(false);
      setExpenseToDelete(null);
    } catch (err) {
      console.error(err);
      alert(t("delete_error"));
    }
  };




  return (
    <div className="w-full max-w-5xl mx-auto mt-10 space-y-6">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold">
            {t("extra_expenses")} #{order.order_code}
          </h1>
          <p className="text-gray-500">
            {t("expense_management")}
          </p>
        </div>

        <Button
          onClick={() => setExpenseModal({})}
        >
          {t("add")}
        </Button>
      </div>

      {/* LIST */}
      <Card>
        {order.extra_expenses?.length === 0 ? (
          <p className="text-gray-500">{t("no_expenses")}</p>
        ) : (
          <div className="space-y-3">
            {order.extra_expenses.map((exp) => (
              <div
                key={exp.id}
                className="border rounded p-3"
              >

                <div className="flex justify-between items-center">
                  <div className="font-semibold">
                    {exp.title}
                  </div>
                  <div className="flex gap-2">
                    <Button
                      variant="edit"
                      onClick={() => setExpenseModal(exp)}
                    >
                      {t("edit")}
                    </Button>
                    <Button 
                      variant="danger"
                      onClick={() => {
                        setExpenseToDelete(exp);
                        setShowDeleteConfirm(true);
                      }}
                    >
                      {t("delete")}
                    </Button>
                  </div>
                </div>
                <div className="text-sm">
                  {t("client")}: ¥{exp.price_client}
                </div>

                <div className="text-sm">
                  {t("price_for_us")}: ¥{exp.price_internal}
                </div>

                {exp.comment && (
                  <div className="text-xs text-gray-500 mt-1">
                    {exp.comment}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </Card>
<ConfirmModal
  isOpen={showDeleteConfirm}
  onClose={() => setShowDeleteConfirm(false)}
  onConfirm={handleDelete}
  title={t("delete_expense_title")}
  description={t("delete_expense_description")}
/>
{expenseModal && (
  <ExtraExpensesModal
    orderId={id}
    expense={
      expenseModal.id
        ? expenseModal
        : null
    }
    onClose={() => setExpenseModal(null)}
    onSuccess={() => {
      setExpenseModal(null);
      window.location.reload();
    }}
  />
)}
    </div>
  );
}

